export const systemName = {
  cms: 'cms',
  dashboard: 'dashboard',
};
